<div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2" style="width: 100%;" *ngIf="ELEMENT_DATA?.length">

      <!-- Template Name Column -->
      <ng-container matColumnDef="subtask_name">
        <th mat-header-cell *matHeaderCellDef> Template Name </th>
        <td mat-cell *matCellDef="let element" class="text-capitalize">
          <div class="d-flex align-content-center">
            <span class="s-icon me-2 mt-2" [ngStyle]="{'background-color': element?.priority?.priority_color}"></span>
            <span class="text-name-cls" [title]="element.subtask_name">{{ element.subtask_name }}</span>

          </div>
        </td>
      </ng-container>

      <!-- Total Task Count Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Created Date </th>
        <td mat-cell *matCellDef="let element"> {{ element?.createdAt ? (element?.createdAt | date) : '-' }} </td>
      </ng-container>
    
      <!-- Total Task Count Column -->
      <ng-container matColumnDef="day_gap">
        <th mat-header-cell *matHeaderCellDef> Days Gap </th>
        <td mat-cell *matCellDef="let element"> {{ element?.day_gap || 0}} </td>
      </ng-container>

      <!-- Total Task Count Column -->
      <ng-container matColumnDef="due_date">
        <th mat-header-cell *matHeaderCellDef> Due Date </th>
        <td mat-cell *matCellDef="let element"> {{ element?.due_date || 0 }} </td>
      </ng-container>

      <!-- Total Task Count Column -->
      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef> Assignee/Group </th>
        <td mat-cell *matCellDef="let element">
                <div *ngIf="element?.assignees?.length > 0">
                  <ng-container
                    *ngFor="
                      let assignees of element?.assignees;
                      let i = index
                    "
                  >
                    <span class="user--img me-2" *ngIf="i < 3">
                      <span class="outer-hover">
                        <div
                          *ngIf="
                            assignees.profile_image?.charAt(0) ==
                              '#' ||
                            !assignees.profile_image ||
                            assignees.profile_image?.charAt(0) !=
                              'h'
                          "
                          class="user-short-name mr-0"
                          [ngStyle]="{
                            'background-color':
                              assignees.profile_image
                          }"
                        >
                          {{
                            utils.forShortName(
                              assignees.first_name +
                                " " +
                                assignees.last_name
                            )
                          }}
                        </div>
                        <img
                          [src]="assignees.profile_image"
                          class="img-avatar"
                          alt="assignee profile"
                          *ngIf="
                            assignees.profile_image?.charAt(0) !==
                              '#' &&
                            assignees.profile_image?.charAt(0) ==
                              'h'
                          "
                        />
                        <span
                          class="online--status"
                          [ngClass]="{
                            'default-active-status':
                              (assignees.id
                                | userState : onlineArr) == 'online'
                          }"
                        ></span>
                        <!-- <app-member-hover
                          class="hoverimg math_ui-onHover-sub-block"
                          [ngClass]="{
                            'assignee_div-only':
                              assignees.profile_image?.charAt(0) ==
                                '#' ||
                              !assignees.profile_image ||
                              assignees.profile_image?.charAt(0) ==
                                'h'
                          }"
                          [ngStyle]="{
                            position: 'absolute',
                            background: '#1e1e1e',
                            'z-index': '3'
                          }"
                          [itemList]="assignees"
                        ></app-member-hover> -->
                      </span>
                    </span>
                  </ng-container>
                  <a
                    href="javascript:void(0)"
                    class="anchor-link"
                    *ngIf="element?.assignees?.length > 3"
                    >+ {{ element?.assignees?.length - 3 }}
                    {{ "MORE" | translate }}</a
                  >
                </div>
                
                <div *ngIf="element?.groups?.length > 0">
                  <ng-container
                    *ngFor="
                      let group of element?.groups;
                      let i = index
                    "
                  >
                    <span class="user--img me-2" *ngIf="i < 3">
                      <div
                        *ngIf="
                          group.profile_image?.charAt(0) == '#' ||
                          !group.profile_image
                        "
                        class="user-short-name mr-0"
                        [ngStyle]="{
                          'background-color': group.profile_image
                        }"
                      >
                        {{ utils.forShortName(group.name) }}
                      </div>
                      <img
                        [src]="group.profile_image"
                        class="img-avatar"
                        alt="assignee profile"
                        *ngIf="
                          group.profile_image &&
                          group.profile_image?.charAt(0) != '#'
                        "
                      />
                    </span>
                  </ng-container>
                  <a
                    href="javascript:void(0)"
                    class="anchor-link"
                    *ngIf="element?.groups?.length > 3"
                    >+ {{ element?.groups?.length - 3 }}
                    {{ "MORE" | translate }}</a
                  >
                </div>
                <div
                  class="d-flex justify-content-center"
                  *ngIf="!element?.groups?.length && !element?.assignees?.length"
                >
                  -
                </div>        
        </td>
      </ng-container>
    
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element" [ngClass]="!userRolePermission?.task?.can_create && !userRolePermission?.superAdmin ? 'disable-cls':''">
        
          <mat-checkbox [disabled]="element?.is_created" [checked]="element?.is_created" (change)="createTemplateTask($event,element?._id,element)"></mat-checkbox>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div class="d-flex justify-content-center" *ngIf="!ELEMENT_DATA?.length">No data found</div>
  </div>
